import Fragment from "vue-fragment";
import VueI18n from "vue-i18n";
import "swiper/css/swiper.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import PortalVue from "portal-vue";
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

export const libConfig = Vue => {
  Vue.config.productionTip = false;
  ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
  Vue.use(PortalVue);
  Vue.use(VueI18n);
  Vue.use(Fragment.Plugin);
  Vue.use(VueAwesomeSwiper);
};
